module.exports = __webpack_public_path__ + "img/AIO5000_aodo_1-1.907e5042.jpg";